import { html, unsafeHTML } from '@resn/gozer-core';
import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import { map, lerp } from '@resn/gozer-math';
import { currentPromotion } from 'data/promotion-data'
import './index.scss';
import  countdown  from 'core/countdown'


import getStore from 'core/store';
import Copy from '@resn/gozer-core/copy';
const store = getStore();

const template = ({ props }) => html`
    <div class="promoBanner">
        <h3 class="promoBanner__text  text-copyTitle2">
            ${unsafeHTML(currentPromotion.bannerText)}
        </h3>
        <h3 class="promoBanner__text  text-copyTitle2" id="pageTimer" style="display:none"></dh3>
    </div>
`;

@componentMixin(DomComponentMixin)
class PromoBanner extends Component {
    options = {
        template,
    };

    props = {
        active: true,
        bannerH: () => store.state.promoBannerHeight,
        yScroll: (props) => map(store.state.scroll, 0, props.bannerH, 0, -props.bannerH - 1, true),
        y: (props) => lerp(store.state.headerRetractPr, props.yScroll, -props.bannerH)
    };

    setY(val) {
        this.el.style.transform = `translateY(${val}px)`;
    }

    async onSetup() {
        this.observer = new ResizeObserver((entries) => {
            const { height } = entries[0].contentRect;
            store.state.promoBannerHeight = height;
        });

        this.observer.observe(this.el);

        if(currentPromotion.showCountdown && new Date() < currentPromotion.countdownToDate){
            countdown.setLabels(
                '| Sec| Min| Hour| Day',
                '| Secs| Mins| Hours| Days',
            );

            document.getElementById('pageTimer').style.display = 'inline'
            
            var timerId = countdown(
                currentPromotion.countdownToDate,
                function(ts) {
                    if(new Date() > currentPromotion.countdownToDate) {
                        window.clearInterval(timerId);
                        document.getElementById('pageTimer').innerHTML = ''
                        document.getElementById('pageTimer').style.display = 'none'
                    } else {
                        document.getElementById('pageTimer').innerHTML = currentPromotion.countdownLabel + ts.toString();
                    }
                },
                countdown.DAYS|countdown.HOURS|countdown.MINUTES|countdown.SECONDS
            );

        }
    }
}

export default PromoBanner;
